<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
@if (tiles.length > 0) {
  <div class="ys-dia-show">
    <div class="ys-dia-show-content"
      (click)="clicked()" (touchstart)="swipe($event, 'start')"
      (touchend)="swipe($event, 'end')">
      <ng-container>
        <ys-carousel-image  
          [@flyInOut]="(index$|async)"  
          [src]="tiles[(index$| async)?? 0].src" 
          [alt]="tiles[(index$| async)?? 0].alt" 
          [imgStyle]="tiles[(index$| async) ?? 0].style" 
          [title]="tiles[(index$| async)?? 0].alt"
          [imgClass]="tiles[(index$| async) ?? 0].class" 
          [sizes]="tiles[(index$| async) ?? 0].sizes" 
          [loading]="tiles[(index$| async) ?? 0].loading" 
          [crossOrigin]="tiles[0].crossOrigin"
          [priority]="tiles[(index$| async)?? 0].priority" 
          [repo]="repo" />
      </ng-container>
    </div>
    @if (config.progressIndicator === true) {
      <div class="ys-dia-show-progress-indicator">
        <mat-progress-bar mode="determinate" [value]="100*((((index$|async) ?? 0)+1)/tilesInput.length)"
        color="primary"></mat-progress-bar>
      </div>
    }
    @if (tilesInput.length > 1 && ((index$|async) ?? 0) > 0 && ((index$|async) ?? 0) < tilesInput.length  && config.controls === true) {
      <div
        class="ys-dia-show-button-left">
        <button type="button" mat-icon-button (click)="left()" class="ys-dia-show-control-button"
          aria-label="Zurück"><mat-icon>chevron_left</mat-icon></button>
        </div>
      }
      @if (tilesInput.length > 1 && tilesInput.length > (((index$|async) ?? 0)+1) && config.controls === true) {
        <div
          class="ys-dia-show-button-right">
          <button type="button" mat-icon-button (click)="right()" class="ys-dia-show-control-button"
            aria-label="Vorwärts"><mat-icon>chevron_right</mat-icon></button>
          </div>
        }
        @if (tilesInput.length > 1 && (state$|async)==='PAUSED' && config.playButton === true) {
          <div
            class="ys-dia-show-button-play">
            <button type="button" mat-icon-button (click)="play()" class="ys-dia-show-control-button"
              aria-label="Autoplay fortsetzen"><mat-icon>play_circle_filled</mat-icon></button>
            </div>
          }
          @if (tilesInput.length > 1 && config.pagination === true) {
            <div class="ys-dia-show-pagination">
              <ul class="ys-dia-show-pagination-list">
                @for (tile of tilesInput; track tile; let idx = $index) {
                  <li [class.active]="idx === (index$|async)" (click)="moveTo(idx)">
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
